import { Navbar} from "rsuite";
import {history} from "../../../_helpers";
import logo from "../../../assets/img/logo-nav-mobile.png";
import React, {useEffect,useState} from "react";
import {toggleMenu} from "../../../assets/js/script";
import {useTranslation, withTranslation} from "react-i18next";
import {LeftOutlined} from '@ant-design/icons';
import {Button} from "antd";
import variables from "_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";

function NavbarBack(props){
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);
    const [link, setLink] = useState("/admin/dashboard");
    const [title, setTitle] = useState("");
    const { t, i18n } = useTranslation();
    useEffect(() => {
        toggleMenu()
        if (userType === 'STUDENT'){
            if (props.current.toLocaleString().toLowerCase().includes("ceiba")
            || props.current.toLocaleString().toLowerCase().includes("tek")
            || props.current.toLocaleString().toLowerCase().includes("cervo")
            || props.current.toLocaleString().toLowerCase().includes("informes")){

                setLink("/admin/informes")
                if (props.current.toLocaleString().toLowerCase().includes("ceiba")){
                    setTitle(t("nnceiba"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("tek")){
                    setTitle(t("nntek"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("cervo")){
                    setTitle(t("nncervo"))
                }
            }else{

                setLink("/admin/dashboard")
            }
        }else{
            if (props.current.toLocaleString().toLowerCase().includes("informes") || props.current.toLocaleString().toLowerCase().includes("responses")) {
                if (props.current.toLocaleString().toLowerCase().includes("ceiba")) {
                    setTitle(t("nnceiba"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("tek")) {
                    setTitle(t("nntek"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("cervo")) {
                    setTitle(t("nncervo"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("nogam3")) {
                    setTitle(t("nngame3"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("nogam4")) {
                    setTitle(t("nngame4"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("nogam5")) {
                    setTitle(t("nngame5"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("nogam6")) {
                    setTitle(t("nngame6"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("xcelence")) {
                    setTitle(t("nnxcelence"))
                }
                if (props.current.toLocaleString().toLowerCase().includes("dinformes")) {
                    setTitle(t("downinformes"))
                }

                setLink("/tutorAuth/students")

            }else{
                setTitle(t("menu.users"));
            }
            setLink("/tutorAuth/students")
        }
    });


    return (
        <>
            <Navbar className={`navbarBack`}>
                {props.current.includes("dashboard") &&
                    <Navbar.Brand  className={"imgLogoLink"}  onClick={() => history.push("/default/index")}><img className={"imgLogo"} src={logo}  alt={""} width={"63"} height={"21"}/></Navbar.Brand>
                }
                {!props.current.includes("dashboard") &&
                    <>
                    <Button className={"navbarBack-btn"} type="primary" shape="circle" onClick={() => history.push(link)} icon={<LeftOutlined />} size={'large'} />
                    <h2 className={"navbarBack-title "}>{title}</h2>
                    </>
                }
            </Navbar>
        </>
    );
}
export default withTranslation()(NavbarBack);
